import styled from "styled-components"
import { Annotation } from "../../common/general-styles.component"

export const TooltipBox = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 10px 24px 0 ${({ theme }) => theme.color.tooltipBoxShadow};
  background-color: ${({ theme }) => theme.color.backgroundInverted};
`
export const TooltipText = styled(Annotation)`
  font-size: ${14 / 16}rem;
  line-height: ${22 / 14}em;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    font-size: ${17 / 16}rem;
    line-height: ${24 / 17}em;
  }
`
